<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue
      :opq-if="estNonRetraite"
      code="orientation-theorique-1"
      v-model="sasRenseignementsProfessionnels.orientationTheorique1"
      :live="liveSasRenseignementsProfessionnels(3404)"
      optional
      :filter="(fd) => fd.value != sasRenseignementsProfessionnels.orientationTheorique2"
      :code-exclude="sas.limitations.orientationsTheoriques"
    ></opq-catalogue>
    <opq-catalogue
      :opq-if="estNonRetraite"
      code="orientation-theorique-2"
      v-model="sasRenseignementsProfessionnels.orientationTheorique2"
      :live="liveSasRenseignementsProfessionnels(3405)"
      optional
      :filter="(fd) => fd.value != sasRenseignementsProfessionnels.orientationTheorique1"
      :code-exclude="sas.limitations.orientationsTheoriques"
    ></opq-catalogue>
    <ressource v-show="estNonRetraite" code="separateur-psychotherapie"></ressource>
    <template v-if="!sas.limitations.psychotherapie">
      <opq-catalogue
        :opq-if="estNonRetraite"
        code="exercice-psychotherapie"
        v-model="sasRenseignementsProfessionnels.exercezVousLaPsychotherapie"
        :live="liveSasRenseignementsProfessionnels(3406)"
        @eudo-updated="exercicePsychotherapieChanged"
      ></opq-catalogue>
    </template>
    <opq-catalogue
      :opq-if="
        estNon(sasRenseignementsProfessionnels.exercezVousLaPsychotherapie) &&
        estOui(sasRenseignementsProfessionnels.exercezVousLaPsychotherapieAncien)
      "
      code="exercice-psychotherapie-raison"
      v-model="sasRenseignementsProfessionnels.motifDuChangement"
      :live="liveSasRenseignementsProfessionnels(3408)"
      orderBy="text"
    ></opq-catalogue>
    <opq-date-picker
      :opq-if="
        estNon(sasRenseignementsProfessionnels.exercezVousLaPsychotherapie) &&
        estOui(sasRenseignementsProfessionnels.exercezVousLaPsychotherapieAncien)
      "
      code="exercice-psychotherapie-date"
      v-model="sasRenseignementsProfessionnels.dateDuChangement"
      :live="liveSasRenseignementsProfessionnels(3407)"
      disabled
      ref="exercicePsychotherapieDate"
    ></opq-date-picker>
    <ressource v-show="estNonRetraite" code="description-dispense"></ressource>
    <opq-catalogue
      :opq-if="estNonRetraite"
      code="langues-maitrisees"
      v-model="sasRenseignementsProfessionnels.languesUtiliseesPourLesServicesOfferts"
      :live="liveSasRenseignementsProfessionnels(3428)"
      multiple
      optional
      width="500"
    ></opq-catalogue>
    <template v-if="!sas.limitations.telepratique">
      <opq-catalogue
        :opq-if="estNonRetraite"
        code="telepratique"
        v-model="sasRenseignementsProfessionnels.serviceTelepratique"
        :live="liveSasRenseignementsProfessionnels(3411)"
      ></opq-catalogue>
      <opq-text-field
        :opq-if="estOui(sasRenseignementsProfessionnels.serviceTelepratique)"
        code="nombre-heures-telepratique"
        is-number
        v-model="sasRenseignementsProfessionnels.nombreHeuresTelepratique"
        :live="liveSasRenseignementsProfessionnels(3413)"
      ></opq-text-field>
    </template>
    <div>
      <ressource v-show="estNonRetraite" code="separateur-clienteles-services"></ressource>
    </div>
    <div>
      <ressource v-show="estNonRetraite" code="description-clienteles-services"></ressource>
    </div>
    <opq-catalogue
      :opq-if="estNonRetraite"
      code="clientele-desservie"
      v-model="sasRenseignementsProfessionnels.clientelesDesservies"
      :live="liveSasRenseignementsProfessionnels(3429)"
      :code-exclude="[...sas.limitations.clientelesDesservies, ...sas.clientelesDesserviesInaccessibles]"
      orderBy="code"
      optional
    ></opq-catalogue>
    <services-offerts
      v-if="estNonRetraite"
      :services-offerts="sas.sasServicesOfferts"
      :sas="sas"
      :limitations="sas.limitations"
      :valids="valids"
      ref="dataIterator_servicesOfferts"
    ></services-offerts>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormHybrid from "@/mixins/FormHybrid"
import ServicesOfferts from "@/components/FormParts/ServicesOfferts"
import { bus } from "@/plugins/bus"
export default {
  mixins: [CataloguesHelper, FormHybrid],
  props: {
    sas: { type: Object },
  },
  components: {
    ServicesOfferts,
  },

  methods: {
    liveSasRenseignementsProfessionnels(cle) {
      return {
        endpoint: "sas-renseignements-professionnels",
        cle: cle,
        fileId: this.sasRenseignementsProfessionnels.id,
      }
    },
    estCategorie(codeCategorie) {
      return (
        this.getCatalogueCodeById(11124, this.sas.sasInscriptionAuTableauRegistre.typeDeCotisation) == codeCategorie
      )
    },
    exercicePsychotherapieChanged(ouiOuNon) {
      if (this.estNon(ouiOuNon)) {
        this.$refs.exercicePsychotherapieDate.setValueToToday()
        bus.$emit("exercicePsychotherapiePasseANon")
      }
    },
  },

  computed: {
    sasRenseignementsProfessionnels() {
      return this.sas.sasRenseignementsProfessionnels
    },
    estNonRetraite() {
      return !this.estCategorie(15)
    },
  },
}
</script>

<style></style>
